import { makeRequest } from "./api";

export const FetchEssentials = async () => {
  return makeRequest("/api/admin//essential/fetch");
};

export const CreateEssential = async (formData) => {
  return makeRequest("/api/admin/essential/create", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateEssential = async (formData) => {
  return makeRequest("/api/admin/essential/update", {
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DeleteEssential = async (essentialTypeId) => {
  return makeRequest(`/api/admin/essential/remove/${essentialTypeId}`, {
    method: "DELETE",
  });
};
